import Sheet from '@/components/ui/Sheet';
import PrimaryButton from '@/components/ui/PrimaryButton';
import { ehIOS, ehAndroid } from '@/lib/navegador';

// Folha curta com o passo a passo para liberar os avisos quando o navegador
// (ou o celular) já bloqueou. Aberta pelo atalho "Avisos no celular" no perfil.
export default function FolhaAvisosBloqueados({
  aberto,
  aoFechar,
}: {
  aberto: boolean;
  aoFechar: () => void;
}) {
  const passos = ehIOS
    ? [
        'Abra os Ajustes do iPhone.',
        'Toque em Notificações › Se Liga.',
        'Ligue “Permitir notificações”.',
      ]
    : ehAndroid
      ? [
          'Abra as Configurações do celular.',
          'Toque em Apps › Se Liga › Notificações.',
          'Ligue as notificações.',
        ]
      : [
          'Toque no cadeado (ou ⓘ) ao lado do endereço.',
          'Abra Notificações (ou Permissões do site).',
          'Permita os avisos do Se Liga.',
        ];

  return (
    <Sheet aberto={aberto} titulo="Avisos bloqueados" aoFechar={aoFechar}>
      <p className="text-[15px] leading-relaxed text-foreground-700">
        O navegador deste celular está bloqueando os avisos do Se Liga. Para liberar:
      </p>

      <ol className="mt-4 space-y-2.5">
        {passos.map((passo, i) => (
          <li key={passo} className="flex items-start gap-2.5">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-bold text-secondary-700">
              {i + 1}
            </span>
            <span className="text-[14px] leading-relaxed text-foreground-700">{passo}</span>
          </li>
        ))}
      </ol>

      <p className="mt-4 rounded-[14px] bg-background-100 px-3.5 py-3 text-[13px] leading-relaxed text-foreground-600">
        Depois de liberar, volte aqui: o atalho passa a mostrar “Ligados” e você pode enviar um
        aviso de teste.
      </p>

      <PrimaryButton cheio className="mt-5" icone="ri-check-line" onClick={aoFechar}>
        Entendi
      </PrimaryButton>
    </Sheet>
  );
}